import { useAtom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { format, startOfMonth } from 'date-fns';
import type { SelectedAccountRef } from './system-admin-ui-config';

export interface AnalyticsSelection {
  account: SelectedAccountRef | null;
  buId: string | null;
  /** YYYY-MM-DD, both inclusive. */
  startDate: string;
  endDate: string;
}

/** The account, brand and range every Internal and Sentinel Analytics page shows; one pick for both, kept for the tab's session. */
export const analyticsSelectionAtom = atomWithStorage<AnalyticsSelection>(
  'analytics-selection',
  {
    account: null,
    buId: null,
    startDate: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
    endDate: format(new Date(), 'yyyy-MM-dd'),
  },
  createJSONStorage(() => sessionStorage),
  { getOnInit: true },
);

export const useAnalyticsSelection = () => useAtom(analyticsSelectionAtom);
